module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Basic Sewing Requirements and Foundation Piecing")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("Basic Sewing Requirements")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Basic sewing requirements")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('i', [_vm._v("Tip")])])]), _c('span', {
    staticClass: "padding"
  }), _vm._v("A recycled, vintage candleholder can be transformed into a handy sewing caddy.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Sewing machine and neutral thread")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Rotary cutter, mat, and board")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Embroidery scissors")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Pins")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Ruler")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Iron and ironing board")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Thread Heaven thread conditioner")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Appliqué glue")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Glue stick")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Metal spatula")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Small hair styling flat iron and silicon mat")])]), _vm._v(" "), _c('p', {
    staticClass: "tip-h"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('b', [_c('i', [_vm._v("Tips")])])]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "padding"
  }), _vm._v("A small hair iron is the perfect tool to rid silk ribbon of any creases and to tame those unruly rayon embroidery threads. Use it with a silicon mat (oven mitt).")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "padding"
  }), _vm._v("A rounded metal icing spatula is a handy tool to have in your sewing box. It assists in creating smooth seams without the danger of pushing through the fabric. Keep the spatula between the layers when pressing the edges.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("Foundation Piecing Requirements")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Foundation fabric")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Interesting fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Lightweight fusible fleece (I use Vilene H630 by Pellon.)")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Sewing machine and neutral thread")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Rotary cutter, mat, and board")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Embroidery scissors")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Freezer paper")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Pins")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Hera marker or marking pencil")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Ruler")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_vm._v("•"), _c('span', {
    staticClass: "padding"
  }), _vm._v("Iron and ironing board")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Here are a few things to remember before beginning:")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "padding"
  }), _vm._v("Most, if not all, projects featured in this book are utility items; they were designed to be used frequently. The choice of fabrics is, therefore, very important. “Fancy” fabrics such as embossed velvets, satins, and antique fabrics do not stand up to the rigors of frequent handling and washing. Select from the wide range of cotton and silk fabrics to create your crazy projects.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "padding"
  }), _vm._v("Crazy quilting is all about the embroidery and embellishing. Take the time to select fabrics that will showcase your seam treatments. Limit the amount of overly busy, fussy fabrics, because the embroidery will struggle to be seen.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "padding"
  }), _vm._v("All the projects featured in this book require a foundation fabric. My foundation fabric of choice is a prewashed calico or quilter’s muslin. There are many alternatives to muslin, but it is helpful to remember that a fabric with a low thread count is less damaging to the delicate fibers of the embroidery threads and silk ribbons as they pass through the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The maker of this antique quilt used a variety of foundation fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "red1"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "padding"
  }), _vm._v("Most projects featured in this book are pieced using the foundation method. There are many methods for piecing a crazy quilt. This is my least favorite stage of the crazy-quilting process, so I like to get it done as simply and quickly as I can. I find the foundation method to be the most accurate; it also allows for the fussy cutting of fabrics, if the need arises. The angular lines created by this method are conducive to seam treatments that may be heavily embroidered and embellished while still retaining the “shape” of the crazy pieces, which I prefer.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Foundation Piecing Method")]), _vm._v(" "), _c('div', {
    staticClass: "note-b"
  }, [_c('p', {
    staticClass: "note-h"
  }, [_c('b', [_vm._v("NOTE")])]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("It is important to note that a generous ½˝ seam allowance is needed in this method of piecing.")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Trace the project design on the matte side of freezer paper. Number all the shapes.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Cut out the shapes from freezer paper; these shapes are now your templates.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Center and trace the project design and numbering onto the foundation fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Trace project design on foundation fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" Stitch along the outer perimeter line of the marked project shape.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("5.")])]), _vm._v(" Select the fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("6.")])]), _vm._v(" Place the shiny side of the freezer paper on the right side of the fabric; press. Freezer paper is slightly transparent, so you can easily fussy cut your fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Place freezer paper template on right side of fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("7.")])]), _vm._v(" Cut out the shapes, adding a ½˝ seam allowance.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("8.")])]), _vm._v(" Place the foundation fabric marked side up. Lay Piece 1 over Area 1 on the foundation fabric; the fabric should cover the perimeter lines of Area 1. Remove the freezer paper (it can be used many times).")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Place Piece 1 over Area 1.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("9.")])]), _vm._v(" Lay Piece 2 right side down on Shape 1. Make sure that when it is stitched, flipped, and pressed, the fabric covers the perimeter lines of Area 2 on the foundation fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("10.")])]), _vm._v(" Place the ruler on the adjoining line between Pieces 1 and 2—lift the fabric slightly until the pencil line is visible. Align the ruler on this line and score the fabric with a Hera marker (or pencil). This is now your stitching line.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Lift fabric until pencil line is visible")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("11.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("Pin and stitch ½˝ past the neighboring lines.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Pin and stitch.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("12.")])]), _vm._v(" Flip over Shape 2 and press well. It is very important to keep your work flat during this stage.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Flip and press.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("13.")])]), _vm._v(" Repeat Steps 8–12, working in numerical order, until the project design is complete.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("14.")])]), _vm._v(" Press well.")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('b', [_c('i', [_vm._v("Tip")])])]), _c('span', {
    staticClass: "padding"
  }), _vm._v("I suggest that you use an appliqué mat or a sheet of baking paper while pressing to prevent the fabrics from scorching.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("15.")])]), _vm._v(" Place the project design wrong side up and sew on the perimeter line of the project shape (the line sewn at Step 7).")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Completed project design")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "red1"
  }, [_c('b', [_vm._v("16.")])]), _vm._v(" Fuse the fleece to the wrong side of the foundation fabric.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3d1d7c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_fm.vue
// module id = 72
// module chunks = 0